// frontend/src/components/ImpersonationBanner.jsx
import React from "react";
import { useAuth } from "../context/AuthContext";

/**
 * ImpersonationBanner — a loud, fixed red bar shown across the top of the main
 * app whenever the current session was entered via an admin impersonation
 * token. Makes it impossible for the operator to forget they're acting as
 * someone else. The session is hard-capped at 15 minutes server-side.
 */
function ImpersonationBanner() {
  const { impersonating, user } = useAuth();
  if (!impersonating) return null;

  return (
    <div
      role="alert"
      className="fixed top-0 inset-x-0 z-50 bg-red-600 text-white text-center text-sm font-semibold py-1.5 px-4 shadow"
    >
      IMPERSONATION MODE — acting as {user?.email ?? "another user"} · session
      expires in 15 minutes
    </div>
  );
}

export default ImpersonationBanner;
